module.exports = __webpack_public_path__ + "static/media/headset.8ab04f79.svg";